import { EntityType } from 'app/agriculture/models/Entities';
import { useMapVisibility } from 'app/agriculture/hooks/useMapVisibility/useMapVisibility';
import { useMemo } from 'react';
import {
    SuspenseWrapper,
    ToastError,
} from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';

export function RenderVisibilityWrapper({
    children,
    type,
}: {
    children: React.ReactNode;
    type: EntityType;
}) {
    const { isVisible } = useMapVisibility();
    const content = isVisible(type) ? children : null;

    // memo important - stops rerender on visibility change
    return useMemo(
        () => (
            <SuspenseWrapper loadingComponent={null} ErrorComponent={ToastError}>
                {content}
            </SuspenseWrapper>
        ),
        [content],
    );
}
